<template>
    <section class="sns-wrap">
        <div class="sns-container">
            <div class="sns-tag--header">
                <div 
                class="sns-tag-box" 
                :class="{ 'actived': index === snsActiveIndex }" 
                v-for="(item, index) in snsTag" 
                :key="`sns-tag-${index}`" 
                @click="selectTag(index)"
                >
                    <i class="iconfont sns-tag-icon" :class="item.iconName"></i>
                </div>
            </div>
            <div class="sns-content" ref="sns-content" @mouseenter="mouseenterEvent" @mouseleave="mouseleaveEvent">
                <!-- twitter -->
                <template v-if="snsName === 'twitter'">
                    <div class="tw-container">
                        <waterfall :col="col" :data="snsData" :height="waterHeight" @scroll.native="scrollBottomEvent">
                            <template>
                                <div class="sns-item" v-for="(item,index) in snsData" :key="index">
                                    <div class="sns-top">
                                        <div class="avatar-box">
                                            <img class="avatar-box--img" :src="formatAvatar(item.author)" alt="">
                                        </div>
                                        <div class="author-info">
                                            <p class="author-info--name">{{ item.author_data.name }}</p>
                                            <p class="author-info--publishtime">{{ formatTime(item.timestamp) }}</p>
                                        </div>
                                    </div>
                                    <div class="sns-img-box">
                                        <img class="sns-img" :src="item.image" alt="">
                                    </div>
                                    <div class="sns-info">
                                        <p class="sns-text">{{ item.tweetText }}</p>
                                        <div class="sns-other">
                                            <span class="sns-post" @click="gotoPost(item.tid)">GO TO POST</span>
                                            <p class="sns-share">
                                                <i class="iconfont iconfacebook sns-share--fb" @click="shareTo('fb', item.tid)"></i>
                                                <i class="iconfont icontwitter sns-share--tw" @click="shareTo('tw', item.tid)"></i>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </waterfall>
                        <loading class="loading" :loading="loading"></loading>
                    </div>
                </template>
                <!-- fb -->
                <template v-else-if="snsName === 'facebook'">
                    <div class="fb-container sns-wait">
                        <div class="sns-wait-content">
                            <img src="../../assets/images/sns/title.png" class="sns-wait--title" alt="">
                            <p class="sns-wait--text">It's time to see a different future in your own eyes.</p>
                            <a class="sns-wait--a" href="https://www.facebook.com/ArknightsGlobal" target="_blank">
                                <img src="../../assets/images/sns/goto_fb.png" class="sns-wait--a-img" alt="">
                            </a>
                        </div>
                    </div>
                </template>
                <template v-else-if="snsName === 'discord'">
                    <div class="discord-container sns-wait">
                        <div class="sns-wait-content">
                            <img src="../../assets/images/sns/title.png" class="sns-wait--title" alt="">
                            <p class="sns-wait--text">It's time to see a different future in your own eyes.</p>
                            <a class="sns-wait--a" href="https://discordapp.com/invite/arknights" target="_blank">
                                <img src="../../assets/images/sns/goto_discord.png" class="sns-wait--a-img" alt="">
                            </a>
                        </div>
                    </div>
                </template>
                <template v-else-if="snsName === 'instagram'">
                    <div class="instagram-container sns-wait">
                        <div class="sns-wait-content">
                            <img src="../../assets/images/sns/title.png" class="sns-wait--title" alt="">
                            <p class="sns-wait--text">It's time to see a different future in your own eyes.</p>
                            <a class="sns-wait--a" href="https://www.instagram.com/arknights_messenger_official" target="_blank">
                                <img src="../../assets/images/sns/goto_instagram.png" class="sns-wait--a-img" alt="">
                            </a>
                        </div>
                    </div>
                </template>
                <template v-else-if="snsName === 'youtube'">
                    <div class="youtube-container sns-wait">
                        <div class="sns-wait-content">
                            <img src="../../assets/images/sns/title.png" class="sns-wait--title" alt="">
                            <p class="sns-wait--text">It's time to see a different future in your own eyes.</p>
                            <a class="sns-wait--a" href="https://www.youtube.com/channel/UCR0J2NYGuC8epsa1O4DMmXQ" target="_blank">
                                <img src="../../assets/images/sns/goto_youtube.png" class="sns-wait--a-img" alt="">
                            </a>
                        </div>
                    </div>
                </template>
            </div>
            <transition name="sns-more">
                <a class="sns-more" :href="viewAllHref" target="_blank" v-show="viewAllBtnShow">VIEW ALL</a>
            </transition>
        </div>
    </section>
</template>

<script>
import dayjs from "dayjs"
import "../../plugins/twitterFetcher_min.js"
import loading from "../../components/loading"

export default {
    name: "Sns",

    components: {
        loading,
    },
    data: () => ({
        snsTag: [
            {
                name: 'twitter',
                iconName: "icontwitter",
                href: "https://twitter.com/ArknightsEN"
            },
            {
                name: 'facebook',
                iconName: "iconfacebook"
            },
            {
                name: "discord",
                iconName: 'icondiscord'
            },
            {
                name: "instagram",
                iconName: "iconinstagram"
            },
            {
                name: "youtube",
                iconName: "iconyoutube"
            }
        ],
        snsActiveIndex: 0,      // 激活的tag标识
        snsData: [],

        // 
        loading: false,
        waterHeight: "100%",
        col: 3,     // 瀑布流列数
        // -----
        viewAllHref: "",
        viewAllBtnShow: false,
        eachTweets: 8,  // 每次获取的个数
        maxTweets: 8,   // 获取tweets的总个数
    }),
    created() {
        this.selectTag(this.snsActiveIndex)
        this.viewAllHref = this.snsTag[this.snsActiveIndex].href
    },
    mounted() {
    },
    watch: {
        
    },
    computed: {
        FULLPAGE() {
            return this.$store.state.HOME_FULLPAGE;
        },
        snsName() {
            return this.snsTag[this.snsActiveIndex].name;
        }
    },
    methods: {
        scrollBottomEvent(e) {      // 滑到底部
            this.$nextTick(() => {
                let eScrollH = e.target.scrollHeight
                let eClientH = e.target.clientHeight
                let eScrollT = e.target.scrollTop

                console.log("scroll bottom")

                if(eClientH + eScrollT >= eScrollH && !this.viewAllBtnShow) {
                    this.maxTweets += this.eachTweets     
                    this.fetcherTwitter(this.maxTweets)
                }
            })
        },
        selectTag(index) {
            // 重置参数
            this.maxTweets = 8
            this.snsData = []
            this.viewAllBtnShow = false

            this.snsActiveIndex = index
            switch (this.snsName) {
                case 'twitter':
                    this.fetcherTwitter(this.eachTweets)    // 第一次获取数据
                    break;
                default:
                    break;
            }
        },
        mouseenterEvent() {
            this.FULLPAGE.fullScrollDisable(true)
        },
        mouseleaveEvent() {
            this.FULLPAGE.fullScrollDisable(false)
        },
        formatTime(time) {
            return dayjs(time).format('MMM DD [at] HH:mm a')
        },
        formatAvatar(author) {
            const objDom = document.createElement("div")
            objDom.innerHTML = author
            return objDom.querySelector('[data-scribe="element:avatar"]').src
        },
        shareTo(channel, tid) {
            this.$utils.tweetShare(channel, "ArknightsEN", tid)
        },
        gotoPost(tid) {
            let channel = this.snsTag[this.snsActiveIndex].name
            let author = "ArknightsEN"

            switch (channel) {
                case "twitter":
                    this.$utils.openWin(`https://twitter.com/${author}/status/${tid}`)
                    break;
                default:
                    break;
            }
        },
        /* ----------- */
        fetcherTwitter(maxTweets) {
            this.loading = true;
            
            const configProfile = {
                "profile": {"screenName": 'ArknightsEN'},
                "maxTweets": maxTweets,
                "enableLinks": true, 
                "showUser": true,
                "showTime": true,
                "showImages": true,
                "lang": 'en',
                "dataOnly": true,
                "customCallback": this.fetchTWData
            }
            twitterFetcher.fetch(configProfile);
        },
        fetchTWData(orgData) {
            const updateDate = orgData.slice(this.maxTweets - this.eachTweets)
            this.snsData = this.snsData.concat(updateDate)
            this.loading = false

            if(orgData.length < this.maxTweets) {
                // 数据拉完了 tw最多20条
                console.log("no more.")
                this.viewAllBtnShow = true
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.sns-wrap {
    background: #141516;

    .sns-container {
        position: relative;
        width: 80%;
        height: 90%;
        max-width: 1400px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        align-items: center;

        .sns-tag--header {
            width: 100%;
            height: pxTorem(87px);
            box-sizing: border-box;
            border: 1px solid #535353; 
            display: flex;

            .sns-tag-box {
                width: pxTorem(85px);
                height: pxTorem(85px);
                background: transparent;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;

                .sns-tag-icon {
                    font-size: pxTorem(27px);
                    color: #fff;
                }

                &.actived {
                    background: #fff;

                    .sns-tag-icon {
                        color: #000;
                    }
                }
            }

            &::after {
                content: "";
                display: block;
                position: absolute;
                right: 1px;
                top: 0;
                color: #535353;
                width: pxTorem(370px);
                border-top: pxTorem(7px) solid #22bbff;
                padding: pxTorem(8px) pxTorem(11px) 0 pxTorem(5px);
            }
        }
        .sns-content {
            flex: 1;
            margin-top: pxTorem(18px);
            width: 100%;
            position: relative;

            .loading {
                position: absolute;
                bottom: 5%;
                left: 50%;
                transform: translateX(-50%);
            }

            .tw-container {
                position: absolute;
                width: 100%;
                height: 100%;

                & ::v-deep .vue-waterfall {
                    @include customScrollBar;
                }

                & ::v-deep .vue-waterfall-column {
                    box-sizing: border-box;
                    padding-right: pxTorem(18px);
                }
                
                .sns-item {
                    width: 100%;
                    box-sizing: border-box;
                    border: 1px solid #535353;
                    padding: pxTorem(24px) pxTorem(32px) pxTorem(10px);
                    &:not(:last-of-type) {
                        margin-bottom: pxTorem(20px);
                    }
                    
                    .sns-top {
                        display: flex;
                        margin-bottom: pxTorem(20px);
                        
                        .avatar-box {
                            width: pxTorem(55px);
                            height: pxTorem(55px);
                            flex-shrink: 0;
                            border-radius: 50%;
                            overflow: hidden;
                            margin-right: pxTorem(20px);

                            .avatar-box--img {
                                display: block;
                                width: 100%;
                            }
                        }
                        .author-info {
                            display: flex;
                            flex-direction: column;

                            .author-info--name {
                                font-size: pxTorem(26px);
                                color: #fff;
                                border-bottom: 1px solid #fff;
                                padding-bottom: pxTorem(5px);
                                margin-bottom: pxTorem(5px);
                            }
                            .author-info--publishtime {
                                font-size: pxTorem(16px);
                                color: #747474;
                            }
                        }
                    }
                    .sns-img-box {
                        width: 100%;

                        .sns-img {
                            display: block;
                            width: 100%;
                        }
                    }
                    .sns-info {
                        margin-top: pxTorem(20px);

                        .sns-text {
                            font-size: pxTorem(16px);
                            color: #747474;
                            word-wrap: break-word;
                        }
                        .sns-other {
                            color: #fff;
                            border-top: 1px solid #535353;
                            margin-top: pxTorem(36px);
                            padding-top: pxTorem(10px);
                            display: flex;
                            justify-content: space-between;
                            align-items: center;

                            .sns-post {
                                font-size: pxTorem(18px);
                                color: #fff;
                                display: flex;
                                cursor: pointer;

                                &::after {
                                    content: ">";
                                    margin-left: pxTorem(12px);
                                }
                            }
                            .sns-share {
                                display: flex;
                                align-items: center;
                                
                                &::before {
                                    content: "SHARE";
                                    font-size: pxTorem(18px);
                                    margin-right: pxTorem(25px);
                                    display: block;
                                }
                                
                                .sns-share--fb {
                                    font-size: pxTorem(26px);
                                    display: block;
                                    margin-right: pxTorem(12px);
                                    cursor: pointer;
                                }
                                .sns-share--tw {
                                    font-size: pxTorem(26px);
                                    display: block;
                                    cursor: pointer;
                                }
                            }
                        }
                    }
                }
            }
            /*  */
            .sns-wait {
                width: 100%;
                height: 0;
                padding-top: 50.28%;
                border: 1px solid #535353;
                box-sizing: border-box;
                color: #fff;
                position: relative;

                &.fb-container {
                    background: url("../../assets/images/sns/bg_fb.jpg") no-repeat;
                    background-size: 100%;
                    background-position: center;
                }
                &.discord-container {
                    background: url("../../assets/images/sns/bg_discord.jpg") no-repeat;
                    background-size: 100%;
                    background-position: center;
                }
                &.instagram-container {
                    background: url("../../assets/images/sns/bg_instagram.jpg") no-repeat;
                    background-size: 100%;
                    background-position: center;
                }
                &.youtube-container {
                    background: url("../../assets/images/sns/bg_yotube.jpg") no-repeat;
                    background-size: 100%;
                    background-position: center;
                }

                .sns-wait-content {
                    position: absolute;
                    width: auto;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .sns-wait--title {
                        display: block;
                        width: pxTorem(600px);
                    }
                    .sns-wait--text {
                        font-size: pxTorem(24px);
                        font-family: "SourceHanSansSubset";
                        white-space: nowrap;
                        margin: pxTorem(92px) 0 pxTorem(130px);
                    }
                    .sns-wait--a {
                        display: block;
                        width: pxTorem(436px);
                        
                        .sns-wait--a-img {
                            display: block;
                            width: 100%;
                        }
                    }
                }
            }
        }
        .sns-more {
            color: #fff;
            font-size: pxTorem(18px);
            border: 1px solid #535353;
            padding: pxTorem(10px) pxTorem(15px);
            margin-top: pxTorem(20px);
            cursor: pointer;
            @include userSelect;
        }
    }
    
    .sns-more-enter-active, .sns-more-leave-active{
        transition: all .3s ease-in-out;
    } 
    .sns-more-enter,.sns-more-leave-to {
        opacity: 0;
    }
}
</style>
